// extracted by mini-css-extract-plugin
export default {"dropdown":"q9_UZ6biYtPn6Gd_kYUr"};